import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-gauge-display',
  templateUrl: './gauge-display.component.html',
  styleUrls: ['./gauge-display.component.scss']
})
export class GaugeDisplayComponent implements OnInit {
  @Input() value: number = 75;
  @Input() width: number = 125;
  @Input() height: number = 100;
  @Input() trend: 'up' | 'down' | null = null;
  @Input() colorStart: string = '';
  @Input() colorEnd: string = '';
  @Input() backgroundColor: string = '';
  @Input() isOnProjectTeam: boolean = false;

  gaugeId: string = 'gaugeGradient-' + Math.random().toString(36).substring(2, 9);

  animatedValue: number = 0;

  readonly radius = !this.isOnProjectTeam ? 60 : 80;
  readonly startAngle = -125;
  readonly endAngle = 125;

  ngOnInit(): void {
    this.animateValue();
  }

  animateValue() {
    const duration = 1000;
    const frameRate = 10;
    const totalFrames = duration / frameRate;
    let frame = 0;

    const interval = setInterval(() => {
      frame++;
      this.animatedValue = Math.min(this.value, (frame / totalFrames) * this.value);
      if (frame >= totalFrames) clearInterval(interval);
    }, frameRate);
  }

  polarToCartesian(cx: number, cy: number, r: number, angleInDegrees: number) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: cx + (r * Math.cos(angleInRadians)),
      y: cy + (r * Math.sin(angleInRadians))
    };
  }

  describeArc(cx: number, cy: number, r: number, startAngle: number, endAngle: number) {
    const start = this.polarToCartesian(cx, cy, r, startAngle);
    const end = this.polarToCartesian(cx, cy, r, endAngle);
    const largeArcFlag = Math.abs(endAngle - startAngle) > 180 ? '1' : '0';
    const pathData = [
      "M", start.x, start.y,
      "A", r, r, 0, largeArcFlag, 1, end.x, end.y
    ].join(" ");

    return pathData;
  }

  get gaugePath(): string {
    const angle = this.startAngle + (this.animatedValue / 100) * (this.endAngle - this.startAngle);
    return this.describeArc(80, 80, this.radius, this.startAngle, angle);
  }

  get backgroundPath(): string {
    return this.describeArc(80, 80, this.radius, this.startAngle, this.endAngle);
  }
}
